import { moduleRoutesList as SurveyModuleRoutesList } from '../modules/survey/router/moduleRouteList';
import { moduleRoutesList as AdminModuleRoutesList } from '../modules/admin-panel/router/moduleRoutes';

export const AppRouteList = [
	...AdminModuleRoutesList,
	...SurveyModuleRoutesList,
];
